/* eslint-disable no-unused-vars */
import React from "react";
import { useDispatch } from "react-redux";
import { Input } from "./styled";
import { modifyValues, calSubTotal } from "../../../../../store/Concept/actions";
import { checkMin, onlyNum } from "../../../../../store/Concept/functions";

const TextField = ({ row, name, defVal, disabled }) => {
  const dispatch = useDispatch();

  const handleChange = (e, row) => {
    dispatch(modifyValues(row, e.target.name, onlyNum(e.target.value)));
  };

  const onBlur = (e, row) => {
    dispatch(modifyValues(row, name, checkMin(e.target.value, name)));
  };

  return (
    <Input
      autoComplete="off"
      defaultValue={defVal}
      name={name}
      onChange={(e) => {
        handleChange(e, row);
      }}
      onBlur={(e) => onBlur(e, row)}
      value={row.original[name]}
      disabled={disabled}
    />
  );
};

export default TextField;
